export default [
    {
        value: 1,
        text: "პერორალურად"
    },
    {
        value: 2,
        text: "ინტრავენურად"
    },
    {
        value: 3,
        text: "ინტრავენურად წვეთობრივად"
    },
    {
        value: 4,
        text: "ინტრავენურად ნაკადურად"
    },
    {
        value: 5,
        text: "ინტრამუსკულურად"
    },
    {
        value: 6,
        text: "სუბლინგვალურად"
    },
    {
        value: 7,
        text: "კანქვეშ"
    },
    {
        value: 8,
        text: "ადგილობრივად"
    },
    {
        value: 9,
        text: "რექტალურად"
    },
    {
        value: 10,
        text: "ნ/გ ზონდით"
    },
    {
        value: 11,
        text: "საინჰალაციო"
    },
    {
        value: 12,
        text: "სპინალურად"
    },
    {
        value: 13,
        text: "ეპიდურულად"
    },
    {
        value: 14,
        text: "საშვილოსნოს ყელში"
    },
    {
        value: 15,
        text: "ინტრაარტერიულად"
    },
    {
        value: 16,
        text: "საშვილოსნოს ღრუში"
    },
    {
        value: 17,
        text: "ინტრაბილიარულად"
    },
    {
        value: 18,
        text: "თვალში ინსტილაცია"
    },
    {
        value: 19,
        text: "ქუთუთოზე შესაზელად"
    },
    {
        value: 20,
        text: "თვალში საინექციოდ"
    },
    {
        value: 21,
        text: "თვალის გამოსარეცხად"
    },
    {
        value: 22,
        text: "ყურში ჩასაწვეთებლად"
    },
    {
        value: 23,
        text: "პირის ღრუში გამოსავლებად"
    },
    {
        value: 24,
        text: "ინფუზიით"
    },
    {
        value: 25,
        text: "ტრანსფუზიით"
    },
    {
        value: 26,
        text: "ინტრანაზალურად"
    },
    {
        value: 27,
        text: "ანტეგრადული"
    },
    {
        value: 28,
        text: "რეტროგრადული"
    },
    {
        value: 29,
        text: "პერინერვული"
    }
]